<template>
  <v-app>
    <v-row no-gutters>
      <v-col lg="4" md="4" sm="12" v-if="$vuetify.breakpoint.mdAndUp">
        <div class="feedback--left">
          <v-container fill-height fluid>
            <v-row align="center" justify="center">
              <v-col>
                <div class="d-flex flex-column align-center">
                  <div
                    class="text-lg-h4 text-capitalize white--text font-weight-bold text-center text-wrap title--width mt-4"
                  >
                    {{
                      $route.name === "FeedbackDocument"
                        ? "Thank You for your feedback"
                        : "Feel Free to drop us your feedback"
                    }}
                  </div>
                </div>
                <div class="mt-3">
                  <div class="d-flex flex-column align-center">
                    <v-img
                      :src="getImage"
                      height="100%"
                      width="100%"
                      class="mx-auto"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>

      <v-col lg="8" md="8" sm="12">
        <router-view />
      </v-col>

      <v-footer
        absolute
        color="rgb(255, 0, 0, 0)"
        class="white--text"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <div class="d-flex justify-space-between">
          <div class="text-body-2 align-self-start">
            {{ appName | capitalize }} © {{ new Date().getFullYear() }} —
            <strong>Kinetic Technology LTD</strong> &emsp;
          </div>
          <div class="text-body-2 align-self-end">
            {{ company.displayName }}
          </div>
        </div>
      </v-footer>
    </v-row>
  </v-app>
</template>

<script>
export default {
  name: "Feedback",
  data: function () {
    return {
      appName: process.env.VUE_APP_NAME,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Feedback/getCompanyInformation");
    });
  },
  computed: {
    getImage() {
      return require("../assets/feedback-svg.png");
    },
    company: function () {
      return this.$store.getters["Feedback/feedbackGetters"](
        "companyInformation"
      );
    },
  },
};
</script>
<style scoped>
@import url("../styles.css");
</style>
